const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        // event.currentTarget.querySelector('.c-accordion__icon svg').classList.toggle('js-active');
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const defaultAccordionMenu = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-menu');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
      });
    }
  };
  const initTooltip = () => {
    const tooltipItems = document.querySelectorAll('.ak-list-tab-item');

    tooltipItems.forEach(item => {
      const tooltip = document.createElement('div');
      tooltip.className = 'table-custom-tooltip';
      tooltip.textContent = item.getAttribute('data-top-tooltip');
      tooltip.style.position = 'fixed';
      tooltip.style.display = 'none';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.zIndex = '9999';
      tooltip.style.willChange = 'transform, top, left';
      tooltip.style.left = '0px';
      tooltip.style.top = '0px';
      document.body.appendChild(tooltip);

        const handleMouseMove = (e) => {
            if (window.innerWidth < 992) {
                tooltip.style.display = 'none';
                return;
            }

            const tooltipRect = tooltip.getBoundingClientRect();

            let left = e.clientX - tooltipRect.width / 2;
            let top = e.clientY - tooltipRect.height - 12;

            if (left < 0) left = 0;
            if (left + tooltipRect.width > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width - 8;
            }
            if (top < 0) top = e.clientY + 15;

            tooltip.style.transform = `translate3d(${left}px, ${top}px, 0)`;
        };

        const handleMouseEnter = () => {
            if (window.innerWidth < 992) return;
            tooltip.style.display = 'block';
        };

        item.addEventListener('mousemove', handleMouseMove);
        item.addEventListener('mouseenter', handleMouseEnter);
        item.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
        });
    });

  window.addEventListener('resize', () => {
      const tooltips = document.querySelectorAll('.table-custom-tooltip');
      tooltips.forEach(tooltip => {
          if (window.innerWidth < 992) {
              tooltip.style.display = 'none';
          }
      });
  });



  };

  const init = () => {
    defaultAccordionMenu();
    defaultAccordion();
    initTooltip();
  };

  return {
    init,
  };
})();

export default accordion;
